import React from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/pages.css";
import Flight from '../components/img/Flight.png';
import Train from '../components/img/Train.png';
import Bus from '../components/img/Bus.png';


function Directions() {
    return (
        <div>
            
            {/* Navbar */}

                <Navbar />

            {/* Navbar Ending */}

            {/* Page Content starts here */}

            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Directions To Reach</p>

                    <div className="d-none d-md-block"> {/* Only works in Desktop */}
                        <p className="page-subtitle">
                            Find your route to Caritas Matha Hospital using our helpful 
                            <br/>
                            directions guide.
                        </p>
                    </div>

                    <div className="d-md-none mb-2">{/* Only works in mobiles */}
                        <p className="page-subtitle">
                            Find your route to Caritas Matha Hospital using our helpful directions guide.
                        </p>
                    </div>

                    <div className="travel">
                        <div className='travel-details'>
                            <p className='travel-title'>Cochin International Airport (COK) : </p>

                            <p>Located approximately 80 kilometers (about 50 miles) from Caritas Matha Hospital, Cochin International Airport is one of the nearest major airports. It offers both domestic and international flights.</p>

                            <p className='travel-title'>Trivandrum International Airport (TRV) : </p>

                            <p>Trivandrum International Airport is approximately 160 kilometers (about 99 miles) away from Caritas Matha Hospital. It is another major airport in the region, providing domestic and international air travel options.</p>
                        </div>
                        <div className='travel-image'>
                            <img src={Flight} alt='Image'/>
                        </div>
                    </div>
                    <div className="travel">
                        <div className='travel-details'>
                            <p className='travel-title'>Kottayam Railway Station : </p>

                            <p>Kottayam Railway Station is the primary railway station in Kottayam, located in the heart of the city. It offers rail connectivity to various parts of India and is the closest railway station to Caritas Matha Hospital.</p>

                            <p className='travel-title'>Ettumanoor Railway Station : </p>

                            <p>Ettumanoor Railway Station is another nearby railway station, located approximately 4.8 kilo-meters (about 3 miles) away from Caritas Matha Hospital. It serves as a convenient option for travellers.</p>
                        </div>
                        <div className='travel-image'>
                            <img src={Train} alt='Image'/>
                        </div>
                    </div>

                    <div className="travel">
                        <div className='travel-details'>
                            <p className='travel-title'>Kottayam Bus Stand : </p>

                            <p>The Kottayam Bus Stand is the main bus station in Kottayam and is located in the city center, making it convenient for travellers. Caritas Matha Hospital is accessible via local transportation options from this bus stand.</p>

                            <p className='travel-title'>KSRTC Bus Stand : </p>

                            <p>The Kerala State Road Transport Corporation (KSRTC) Bus Stand in Kottayam serves as a hub for various state and inter-state buses. It's located in close proximity to Caritas Matha Hospital.</p>
                        </div>
                        <div className='travel-image'>
                            <img src={Bus} alt="Image"/>
                        </div>
                    </div>
                </div>
                <section>
                    <div className="map-container">
                        <div className='map-title'>
                            <p className="sub-heading">Google Map Location</p>
                        </div>
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3933.429665891083!2d76.54812431602198!3d9.64830593217464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07d358c6fffffd%3A0x28bcae68ab08dd22!2sMatha%20Hospital!5e0!3m2!1sen!2sin!4v1697534628764!5m2!1sen!2sin"
                            width="95%"
                            height="500"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade">
                        </iframe>
                    </div>
                </section>
            </section>

            {/* Page content ends here */}

            {/* Footer */}

                <Footer />

            {/* Footer Ending */}

        </div>
    );
}

export default Directions;